export default {
  macAddress: {
    invalidFormat: {
      notes: 'Validation error for invalid mac address',
      message: 'Invalid format',
    },
  },
};
